import { ACCESS_TOKEN_KEY } from 'common/config/constants';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from 'common/utils/methods/handleLocalStorage';

export const logout = (): void => {
  removeLocalStorageItem(ACCESS_TOKEN_KEY);
};

export const setAccessToken = (token: string): void => {
  setLocalStorageItem(ACCESS_TOKEN_KEY, token);
};

export const getAuthHeader = (): string => {
  const token = getLocalStorageItem(ACCESS_TOKEN_KEY);

  return `Bearer ${token}`;
};
